import * as vp from 'vopay';
import { FunctionComponent, useEffect } from 'react';

import { Link } from 'react-router-dom';
import { useLayout } from '../../../providers/Layout.provider';
import { useIQ11UserLogin } from '../../../providers/IQ11Login.provider';
import { useToken } from '../../../providers/Token.provider';
import styles from './LoginForm.module.scss';
import LoginForm from './LoginForm';

const { Box, Button, Icon } = vp;

type FC = FunctionComponent;
const LoginContainer: FC = () => {
  const { setLayoutInfo } = useLayout();
  const { isSubmitting, login } = useIQ11UserLogin();
  const { token } = useToken();
  const defaultValues: vp.IQ11Login = {
    EmailAddress: '',
    Password: '',
  };

  const handlers = {
    login: (_values: vp.IQ11Login) => {
      login(_values);
    },
  };

  useEffect(() => {
    setLayoutInfo(
      vp.chooseColor<string | null | undefined>('#FFD147', token?.BrandingDetails?.Branding?.PrimaryColor),
      'curve',
      '',
      80,
      20,
      0,
      false,
      false,
    );
  }, []);

  return (
    <>
      <Box jc="center" mb="sm">
        <Icon icon="logoELinx" size="xlg" width="300px" />
      </Box>

      <LoginForm defaultValues={defaultValues} handlers={handlers} isSubmitting={isSubmitting} />

      <div className={styles.profileContainer}>
        Don't have an account yet?
        <Link to={{ pathname: '/Profile-Type' }}>
          <Button id="create-profile" label="Create Profile" color="none" textColor="#2D2D2D" textSize={1} />
        </Link>
      </div>
    </>
  );
};

export default LoginContainer;
